import React, { useEffect, useState } from 'react';
import { isValidSessionToken, SESSION_EXPIRED_EVENT } from '../services/ltiSession';

// Bloquea el render de la app si no hay un session token LTI valido. Cubre
// dos casos:
//   1. Carga inicial sin ?session= (alguien abrio la URL directamente).
//   2. 401 durante uso: el wrapper HTTP emite SESSION_EXPIRED_EVENT y el
//      guard reacciona sin tener que recargar la pagina.
//
// Solo se aplica a la ruta "/" en index.js. /admin tiene su propia auth
// (x-admin-password) y no pasa por aqui.
// Bypass para desarrollo local: con REACT_APP_DISABLE_LTI=true el guard
// no valida el token (util si el backend tambien corre con
// LTI_SESSION_REQUIRED=false). Doble candado: ademas exigimos
// NODE_ENV !== 'production' para que un `.env.local` filtrado en el build
// de prod no abra la app sin auth.
const DISABLE_LTI =
    process.env.REACT_APP_DISABLE_LTI === 'true'
    && process.env.NODE_ENV !== 'production';

function SessionGuard({ children }) {
    const [invalid, setInvalid] = useState(() => !DISABLE_LTI && !isValidSessionToken());

    useEffect(() => {
        if (DISABLE_LTI) return undefined;
        const onExpired = () => setInvalid(true);
        window.addEventListener(SESSION_EXPIRED_EVENT, onExpired);
        return () => window.removeEventListener(SESSION_EXPIRED_EVENT, onExpired);
    }, []);

    if (invalid) {
        return (
            <div
                role="alert"
                style={{
                    minHeight: '100vh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '2rem',
                    fontFamily: 'system-ui, -apple-system, sans-serif',
                    background: '#fafaf9',
                }}
            >
                <div style={{ maxWidth: 520, textAlign: 'center' }}>
                    <h2 style={{ marginBottom: '0.75rem', color: '#1A4731' }}>Sesion no valida</h2>
                    <p style={{ color: '#57534e', lineHeight: 1.5 }}>
                        Por favor accede al simulador desde el curso de Moodle.
                        Si abriste el simulador en una pestana nueva y ha pasado tiempo,
                        tu sesion puede haber expirado.
                    </p>
                </div>
            </div>
        );
    }

    return children;
}

export default SessionGuard;
